module.exports = __webpack_public_path__ + "static/media/back arrow.635bd71c.svg";